module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.filteredLatestNews) ? _c('div', {
    staticClass: "headline-panel",
    attrs: {
      "id": "headline-panel"
    }
  }, [_c('figure', {
    staticClass: "effect-julia"
  }, [(_vm.filteredLatestNews.featured_image) ? _c('img', {
    attrs: {
      "src": _vm.filteredLatestNews.featured_image,
      "alt": "img22"
    }
  }) : _c('img', {
    attrs: {
      "src": "http://lorempixel.com/640/480/",
      "alt": "aperçu"
    }
  }), _vm._v(" "), _c('figcaption', [_c('h3', [_c('span', [_vm._v(_vm._s(_vm.filteredLatestNews.title))])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("par " + _vm._s(_vm.filteredLatestNews.user.username))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.detaillUrl
    }
  }, [_vm._v("View more")])], 1)])]) : _c('div', [_c('spinner')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba25fbea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/headline.vue
// module id = 796
// module chunks = 0